

const { createSlice,  } = require("@reduxjs/toolkit");

const initialState = {
    sort: "",
    filter:"All"
   
};

// async thunk


const filterSlice = createSlice({
    name: "filterSlice",
    initialState,
    reducers:{
        sorting:(state, action)=>{
            state.sort = (action.payload);
        },
        filtering:(state, action)=>{
            state.filter = (action.payload);
        },
    }
   
});

export default filterSlice.reducer;
export const {sorting ,filtering} = filterSlice.actions;